import { getCurrentAge, getFullName } from "./utils/personalInfoUtils.ts";

// Personal information constants that don't require translation, and is used globally within the application.

export const firstName: string = "Xander";
export const lastName: string = "Briem";
export const fullName: string = getFullName(firstName, lastName);
export const email: string = "xanderbwerk@gmail.com";
export const githubUsername: string = "99061142";
export const linkedInUsername: string = `${firstName.toLowerCase()}-${lastName.toLowerCase()}`;

const birthDate: string = "2003-08-20"; // YYYY-MM-DD format
const timeZone: string = "Europe/Amsterdam";
export const age: number = getCurrentAge(birthDate, timeZone);

/**
 * College information structure.
 */
interface CollegeInfo {
    name: string;
    location: string;
}

export const college: CollegeInfo = {
    name: "Da Vinci College",
    location: "Dordrecht"
} as const;